import { Fragment } from 'react'

import { getTableRowQaProps, TableCellFreeSpaceFiller } from '../../Table'

import { renderCell } from './ReportTableModalRow.utils'

import * as styles from './ReportTableModalRow.module.css'

function ReportTableModalRow({ columns, emptyColumnSize, item }) {
  const qaProps = getTableRowQaProps()

  return (
    <div {...qaProps} className={styles.ReportTableModalRow} key={item.id}>
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({ item, name: column.name, width: column.width })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default ReportTableModalRow
